<template>
  <div class="promo" :class="{ open: isOpen, TA: isTestAchat }">
    <button type="button" class="promo__header" :aria-expanded="isOpen ? 'true' : 'false'" @click="isOpen = !isOpen">
      <img class="promo__icon" src="@/assets/icons/promo_pink_icon.svg" alt="" />
      <span class="promo__total">-€{{ total | formatPrice }}</span>
      <span class="promo__unit">/{{ unit }}</span>
      <span class="promo__chevron"></span>
    </button>
    <ul class="promo__list" v-if="isOpen">
      <li class="promo__line" v-for="(promo, index) in promos" :key="index">
        <img class="promo__check" src="@/assets/icons/checkV_pink_icon.svg" alt="" />
        <span class="promo__text">
          <strong>-{{ promo.amountLabel }}</strong> <span class="promo__line-unit">/{{ unit }}</span>
          <span class="promo__label">{{ promo.label }}</span>
        </span>
        <button type="button" class="promo__info" v-if="promo.hasText" :aria-label="$t('promo.info')" @click="$emit('info', promo.promoType)">i</button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// ER-3062: accordion of the promotions of a product card. The card only shows the total, the list of
// promotions is in the dropdown. A promotion with a text (cashbacks managed in Hypermega) has an "i" button.
export default {
  name: "PromoAccordion",
  props: {
    // Total of the promotions for the displayed frequency.
    total: {
      type: Number,
      required: true
    },
    // Label of the displayed frequency ("mois", "trimestre").
    unit: {
      type: String,
      required: true
    },
    // [{ promoType, label, amountLabel, hasText }]
    promos: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    ...mapGetters("common", ["isTestAchat"])
  }
};
</script>

<style lang="scss" scoped>
.promo {
  margin: 8px 10px;
  border: 1px solid $pink;
  border-radius: 8px;
  background: $white;
  text-align: left;

  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 6px 8px;
    border: 0;
    background: transparent;
    color: #000;
    font-weight: 700;
    cursor: pointer;
  }

  &__icon {
    height: 20px;
    margin-right: 6px;
  }

  &__unit {
    margin-left: 3px;
    font-size: 0.6rem;
    font-weight: 400;
  }

  &__chevron {
    width: 8px;
    height: 8px;
    margin-left: 10px;
    border-right: 2px solid $pink;
    border-bottom: 2px solid $pink;
    transform: rotate(45deg);
    transition: transform 0.2s;
  }

  &.open &__chevron {
    transform: rotate(-135deg);
  }

  &__list {
    margin: 0;
    padding: 0 8px 8px;
    list-style: none;
  }

  &__line {
    display: flex;
    align-items: flex-start;
    padding: 4px 0;
    font-size: 0.7rem;
    line-height: 1.2;
  }

  &__check {
    width: 14px;
    margin: 2px 6px 0 0;
  }

  &__text {
    flex: 1;
  }

  &__label {
    display: block;
  }

  &__info {
    width: 16px;
    height: 16px;
    margin-left: 6px;
    border: 0;
    border-radius: 50%;
    background: #ddd;
    font-size: 0.6rem;
    font-weight: 700;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/simulation/PromoAccordion.vue